/**
 * LoadingScreen - Fullscreen loading with Core Carousel logo
 *
 * Two variants:
 * - fullscreen: Centers CoreStudioLogo on the full page (for initial load, auth check)
 * - inline: Small CoreStudioMark (for in-component loading states)
 *
 * Usage:
 *   <LoadingScreen />                    // Fullscreen with logo
 *   <LoadingScreen variant="inline" />   // Small inline loader
 *   <LoadingScreen message="Carregando projetos..." /> // With custom message
 */

import React from 'react';
import CoreStudioLogo from './core-studio-logo';
import CoreStudioMark from './core-studio-mark';

interface LoadingScreenProps {
  variant?: 'fullscreen' | 'inline';
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  variant = 'fullscreen',
  message,
}) => {
  if (variant === 'inline') {
    return (
      <div className="flex items-center justify-center gap-3 p-4">
        <CoreStudioMark size={32} />
        {message && (
          <span className="text-sm text-muted-foreground">{message}</span>
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <CoreStudioLogo width={280} className="text-foreground" />
      {message && (
        <p className="mt-6 text-sm text-muted-foreground animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingScreen;
